/**
 * Created by Mark on 18/04/2017.
 */

import LanguageServices from '../../services/language-services.js';
import LanguageStore from '../../store/language-store.js';
import React from 'react';
import '../../css/muilt-select.css';
import Select from  'react-select';
import { FormattedMessage } from 'react-intl';

export default class StaffTypeSelector extends React.Component {

    constructor(props){
        super();
        this.state = {value:'school_teacher'};
        this.props = props;
        this.onChange = this.onChange.bind(this);
    }

    onChange(value){

        console.log(value);
        this.props.onChange({value:value.value});
        this.setState({value:value})
    }

    render(){

        var options = [
            { value: 'school', label: <FormattedMessage id={ 'ui-681' } defaultMessage={ 'Admin' }/>},
            { value: 'school_teacher', label: <FormattedMessage id={ 'ui-323' } defaultMessage={ 'Teacher' }/>}

        ];


        return <Select onChange={this.onChange}name="form-field-name" value={this.state.value} options={options} 
                noResultsText={<FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found" }/>}
                placeholder={<FormattedMessage id={ 'ui-892' } defaultMessage={ 'Select' }/>}/>
    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/staff-types-selector.js